import * as Yup from 'yup';

import { Strings } from '@app/constants';

export const addScheduleSchema = Yup.object()
  .shape({
    name: Yup.string().trim().required(Strings.validation.fieldRequired(Strings.field.name)),
    priority: Yup.string()
      .trim()
      .required(Strings.validation.selectRequired(Strings.dashboard.setThePriority)),
    date: Yup.string().trim().required(Strings.validation.selectRequired(Strings.field.date)),
  })
  .required();
